import { Route } from '@angular/router';
import { cmsAuthGuard } from '@arrk-nx/arrk-cms-libs';
import { AccessDeniedComponent } from './access-denied.component';
export const appRoutes: Route[] = [
  {
    path: '',
    canActivate: [cmsAuthGuard],
    loadComponent: () =>
      import('@arrk-nx/arrk-cms-libs').then((m) => m.CmsLayoutComponent),
    children: [
      { path: '', redirectTo: 'products', pathMatch: 'full' },
      {
        path: 'products',
        loadComponent: () =>
          import('@arrk-nx/arrk-cms-libs').then((m) => m.CmsProductsComponent)
      },
      {
        path: 'services',
        loadComponent: () =>
          import('@arrk-nx/arrk-cms-libs').then((m) => m.CmsServicesComponent)
      },
      {
        path: 'news',
        loadComponent: () =>
          import('@arrk-nx/arrk-cms-libs').then((m) => m.CmsNewsComponent)
      }
    ]
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  }
];
